/**
 * Created by Santiago on 12/6/17.
 */
export default {
    shareScreen: "¿Le gustaría compartir la pantalla?",
    no: 'No',
    yes: 'Si',
    youmustpickastar: 'Debe elegir una calificación',
    name: 'Nombre',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    message: 'Mensaje',
    sendMessage: 'Enviar mensaje',
    newConversation: 'Nueva conversación',
    sendpunctuation: "Enviar calificación",
    musttypemail: 'Debe ingresar su correo electrónico',
    validemail: 'No es un correo electrónico válido',
    musttypename: 'Debe ingresar su nombre',
    musttypemessage: 'Debe escribir un mensaje',
    configuration: 'Configuración',
    notifications: 'Notificaciones',
    screenshare: "Compartir Pantalla",
    notificationDetails: 'Notificarme sobre nuevos mensajes que reciba en esta conversación',
    close: 'Cerrar',
    cancel: 'Cancelar',
    save: 'Guardar',
    willclose: 'Cerrando Conversación',
    closeconf: '¿Está seguro que quiere cerrar la conversación?',
    conversationend: 'La conversación ha finalizado, ¿Desea cerrarla?',
    newmessage: 'Nuevo mensaje',
    typehere: 'Envía un mensaje ...',
    whatdoyouthink: '¿Qué piensa acerca del servicio brindado?',
    sendbymail: 'Enviar conversación por email',
    holdtimeavg: 'Tiempo promedio de espera',
    holdtime: 'Su tiempo de espera',
    messagesended: 'Mensaje enviado',
    emailerror: "Debe ingresar un correo válido para continuar",
    fieldserror: "Por favor verifique los campos e intente nuevamente",
    messageserror: 'Oops, algo salio mal :(',
    message: 'Escribe tu mensaje...',
    transfering: 'Transfiriendo...',
    endchat: 'Finalizar chat',
    videocall: 'Videollamada',
    call: 'Llamada',
    openinextarnalwindow: 'Abrir en ventana externa',
    calling: 'Llamando',
    callingduration: 'Duración de la llamada',
    mute: 'Mute',
    allowmicrophone: 'Permitir micrófono',
    hangup: 'Colgar',
    duration: 'Duración ',
    write: 'Escribir',
    survey_title: 'Esperamos haberte asistido',
    survey_desc: 'Agradecemos que se tome el tiempo para contarnos que piensa del servicio brindado, estos datos nos ayudan a seguir brindandole un servicio óptimo!',
    available: "Disponible",
    invalidextension: "Formato de archivo adjunto inválido",
    maxfilesize10mb: "Tamaño máximo de archivos 10 MB",
    accessibility: "Accesibilidad",
    accessibilityMenu: "Menú de accesibilidad",
    "Font size": "Tamaño de fuente",
    emojis: {
      search: "Buscar",
      notfound: "No se encontraron emojis",
      title: "Elija un emoji",
      categories: {
        search: "Resultados de la búsqueda",
        recent: "Usados frecuentemente",
        people: "Rostros y personas",
        nature: "Animales y naturaleza",
        foods: "Comida y bebida",
        activity: "Actividad",
        places: "Viajes y lugares",
        objects: "Objetos",
        symbols: "Símbolos",
        flags: "Banderas",
        custom: "Personalizados",
      },
    },
};